<template>
  <div class="homeindex">
    <div class="topbanner contain">
      <div class="bancontop contain">
        <h2>
          Providing one-stop SMS solutions to enterprises for connecting
          globally
        </h2>
      </div>
      <div class="bannergroup contain">
        <div class="workgroup-con contain nav-group">
          <div class="nav-item">
            <p class="nav-title">International SMS</p>
            <p class="nav-desc">covering 220+ countries and regions</p>
          </div>
          <div class="nav-item">
            <p class="nav-title">Domestic SMS</p>
            <p class="nav-desc">arrives within 3s, and arrive rate up to 99%</p>
          </div>
          <div class="nav-item">
            <p class="nav-title">International Voice</p>
            <p class="nav-desc">high-quality voice channel resource</p>
          </div>
          <div class="nav-item">
            <p class="nav-title">International SMS</p>
            <p class="nav-desc">
              high efficiency network optimization solutions
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="bannergroup_h5 contain">
        <swiper :options="swiperOptionsH5" class="h5-swiper" ref="h5Swiper">
          <swiper-slide class="swiper-slide">
            <div class="workgroup-con contain nav-group">
              <div class="nav-item">
                <p class="nav-title">International SMS</p>
                <p class="nav-desc">covering 220+ countries and regions</p>
              </div>
              <div class="nav-item">
                <p class="nav-title">Domestic SMS</p>
                <p class="nav-desc">
                  arrives within 3s, and arrive rate up to 99%
                </p>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <div class="workgroup-con contain nav-group">
              <div class="nav-item">
                <p class="nav-title">International Voice</p>
                <p class="nav-desc">high-quality voice channel resource</p>
              </div>
              <div class="nav-item">
                <p class="nav-title">International SMS</p>
                <p class="nav-desc">
                  high efficiency network optimization solutions
                </p>
              </div>
            </div>
          </swiper-slide>
        <div class="swiper-button-prev h5-swiper-prev"></div>
        <div class="swiper-button-next h5-swiper-next"></div>
        <div class="swiper-pagination h5-swiper-pagination"></div>
        </swiper>
      </div> -->
      <div class="bannergroup_h5 contain">
        <el-carousel 
          :interval="2000" 
          arrow="always" 
          indicator-position="outside"
          class="h5-carousel"
        >
          <!-- 第一页轮播内容 -->
          <el-carousel-item>
            <div class="workgroup-con contain nav-group">
              <div class="nav-item">
                <p class="nav-title">International SMS</p>
                <p class="nav-desc">covering 220+ countries and regions</p>
              </div>
              <div class="nav-item">
                <p class="nav-title">Domestic SMS</p>
                <p class="nav-desc">arrives within 3s, and arrive rate up to 99%</p>
              </div>
            </div>
          </el-carousel-item>
          
          <!-- 第二页轮播内容 -->
          <el-carousel-item>
            <div class="workgroup-con contain nav-group">
              <div class="nav-item">
                <p class="nav-title">International Voice</p>
                <p class="nav-desc">high-quality voice channel resource</p>
              </div>
              <div class="nav-item">
                <p class="nav-title">International SMS</p>
                <p class="nav-desc">high efficiency network optimization solutions</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="main contain">
      <div class="feature-title">
        <h2>Professionally drive customer growth</h2>
      </div>
      <div class="main-content">
        <div class="feature-list">
          <!-- 点击切换展示内容 -->
          <div
            :class="['feature-item', { active: showDetail === 1 }]"
            @click="changeContent(1)"
          >
            <img src="../assets/img/newhome/01@2x1.png" alt="" />
            <div>Customer Acquisition</div>
          </div>
          <div
            :class="['feature-item', { active: showDetail === 2 }]"
            @click="changeContent(2)"
          >
            <img src="../assets/img/newhome/02@2x1.png" alt="" />
            <div>Customer Activation</div>
          </div>
          <div
            :class="['feature-item', { active: showDetail === 3 }]"
            @click="changeContent(3)"
          >
            <img src="../assets/img/newhome/03@2x1.png" alt="" />
            <div>Customer Retention</div>
          </div>
        </div>
        <div class="feature-detail" v-if="showDetail === 1">
          <div class="feature-desc">
            <p>Increase registration conversion rate</p>
            <ul>
              <li>
                <b>.Registration and login</b><br />
                <p>
                  The dynamic verification code can be received within 3s,
                  achieve a high-precision arrival rate of 99% through
                  intelligent routing, which can effectively reduce registration
                  loss and increase the registration conversion rate by 20%
                </p>
              </li>
              <li>
                <b>.Identity authentication</b><br />
                <p>
                  Verify real identities and ensure information security; Bind a
                  real mobile phone, retrieve the password, verify and change
                  important information, and confirm payment
                </p>
              </li>
              <li>
                <b>.Secure assurance</b><br />
                <p>
                  Effectively block anomalous requests ,which can prevent cyber
                  attacks; Confirm sensitive operation,which can protect account
                  security
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="feature-imgright" v-if="showDetail === 1">
          <img
            class="feature-img"
            src="../assets/img/newhome/01@2x.png"
            alt=""
          />
        </div>
        <div class="feature-detail" v-if="showDetail === 2">
          <div class="feature-desc">
            <p>Activate users to achieve marketing conversions</p>
            <ul>
              <li>
                <b>·Marketing Promotion</b><br />
                <p>
                  Promote brand effects through new promotions on products,
                  event notifications, member rights and interests issuance,
                  coupon collection, etc., thereby increasing conversion rates
                  and repurchase rates
                </p>
              </li>
              <li>
                <b>·Interaction and activation</b><br />
                <p>
                  Send service or reminder notifications at the right time to
                  connect customers in the right way and enhance user stickiness
                </p>
              </li>
              <li>
                <b>·Transaction tracking</b><br />
                <p>
                  Send messages notifications to customers at the key nodes of
                  the order to improve the order conversion rate, while allowing
                  customers to have a perfect delivery experience
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="feature-imgright" v-if="showDetail === 2">
          <img
            class="feature-img"
            src="../assets/img/newhome/02@2x.png"
            alt=""
          />
        </div>
        <div class="feature-detail" v-if="showDetail === 3">
          <div class="feature-desc">
            <p>lncrease customer value and extend customer lifecycle</p>
            <ul>
              <li>
                <b>·Improve user stickiness</b><br />
                <p>
                  By sending holiday marketing and birthday care SMS as well as
                  notification SMS of transaction key node to improve user
                  experience and stickiness
                </p>
              </li>
              <li>
                <b>·lncrease customer value</b><br />
                <p>
                  The marketing plan accurately hits the customer group, and the
                  secondary marketing realizes the promotion of value-added
                  services and exclusive coupon collection to enhance customer
                  value
                </p>
              </li>
              <li>
                <b>·Customer recall</b><br />
                <p>
                  Select target customer groups, convey promotion information to
                  them, quickly attract old members to revisit and shop, and
                  extend customer lifecycles
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="feature-imgright" v-if="showDetail === 3">
          <img
            class="feature-img"
            src="../assets/img/newhome/03@2x.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="busines">
      <div class="busines-title contain">
        <h2>Engaged in the communications business for 16 years</h2>
      </div>
      <div class="busines-cont contain">
        <div class="busines-list">
          <div class="busines-item">
            <div class="busines-img">
              <img src="../assets/img/newhome/01wd@2x.png" alt="" />
            </div>
            <div class="bus-ri">
              <div class="bus-title">
                <h4>High Stability</h4>
              </div>
              <div class="bus-desc">
                <p>·Self-developed carrier-grade monitoring system</p>
                <p>
                  ·Large capability and high concurrency of dedicated computer
                  room
                </p>
                <p>·Distributed architecture</p>
              </div>
            </div>
          </div>
          <div class="busines-item">
            <div class="busines-img">
              <img src="../assets/img/newhome/023miao@2x.png" alt="" />
            </div>
            <div class="bus-ri">
              <div class="bus-title">
                <h4>Fast Arrival</h4>
              </div>
              <div class="bus-desc">
                <p>
                  ·Arrives within 3s, customer can be maintained in real time
                </p>
                <p>·Intelligent shunting/router realizes 99% arrival rate</p>
                <p>·Triple-play dedicated direct channel</p>
              </div>
            </div>
          </div>
          <div class="busines-item">
            <div class="busines-img">
              <img src="../assets/img/newhome/03quanq@2x.png" alt="" />
            </div>
            <div class="bus-ri">
              <div class="bus-title">
                <h4>Global Focus</h4>
              </div>
              <div class="bus-desc">
                <p>·Covering 220+ countries and regions</p>
                <p>·High-quality voice channel resource</p>
                <p>·High efficiency network optimization solutions</p>
              </div>
            </div>
          </div>
          <div class="busines-item">
            <div class="busines-img">
              <img src="../assets/img/newhome/04zy@2x.png" alt="" />
            </div>
            <div class="bus-ri">
              <div class="bus-title">
                <h4>Professional Services</h4>
              </div>
              <div class="bus-desc">
                <p>·7×24 professional services</p>
                <p>·1v1 technical support</p>
                <p>·Extremely fast response within 5s</p>
              </div>
            </div>
          </div>
          <div class="busines-item">
            <div class="busines-img">
              <img src="../assets/img/newhome/05sj@2x.png" alt="" />
            </div>
            <div class="bus-ri">
              <div class="bus-title">
                <h4>Data Tracking</h4>
              </div>
              <div class="bus-desc">
                <p>·Tracking SMS status in real time</p>
                <p>·Data automatic collecting</p>
                <p>·Visual reports at a glance</p>
              </div>
            </div>
          </div>
          <div class="busines-item">
            <div class="busines-img">
              <img src="../assets/img/newhome/06cs@2x.png" alt="" />
            </div>
            <div class="bus-ri">
              <div class="bus-title">
                <h4>Free Test</h4>
              </div>
              <div class="bus-desc">
                <p>·All channels support the free test</p>
                <p>·Easy to operate</p>
                <p>·Concise and clear API</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mapword contain">
      <div class="mapword-title">
        <h2>Trusted by millions of customers around the world</h2>
      </div>
      <div class="mapword-box">
        <div class="mapword-cont">
          <div class="numword">
            <p class="num">20万+</p>
            <p class="con">Trusted by Customer</p>
          </div>
          <div class="numword">
            <p class="num">10亿+</p>
            <p class="con">SMS Sending Account Monthly</p>
          </div>
          <div class="numword">
            <p class="num">220+</p>
            <p class="con">Countries and Regions Coverage</p>
          </div>
          <div class="numword">
            <p class="num">99.95%</p>
            <p class="con">Stable Uptime</p>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-us">
      <div class="contact-us-title contain">
        <h2>Contact us</h2>
      </div>
      <div class="contact-us-contain contain">
        <div class="contact-us-box">
          <div class="contact-us-left">
            <img src="@/assets/img/newhome/contact@2x.png" alt="" />
          </div>
          <div class="contact-us-right">
            <div class="contact-us-right-cont-box">
              <h5>GET FREE TEST CHANNEL</h5>
              <h6>
                Submit your intention, and we will contact you at the first time
              </h6>
              <div class="contact-form">
                <div class="form">
                  <input
                    type="text"
                    id="name"
                    placeholder="Name"
                    :value="formData.currUid"
                    @input="formData.currUid = $event.target.value"
                  />
                  <input
                    type="number"
                    id="phone"
                    placeholder="Phone"
                    :value="formData.phone"
                    @input="formData.phone = $event.target.value"
                  />
                  <div>Requirements</div>
                  <div class="check">
                    <button
                      :class="
                        formData.temp2 === 'International SMS' ? 'active' : ''
                      "
                      @click="choose('International SMS')"
                    >
                      International SMS
                    </button>
                    <button
                      :class="formData.temp2 === 'Domestic SMS' ? 'active' : ''"
                      @click="choose('Domestic SMS')"
                    >
                      Domestic SMS
                    </button>
                  </div>
                  <textarea
                    id="reamrk"
                    cols="30"
                    rows="10"
                    placeholder="Reamrk"
                    :value="formData.cont"
                    @input="formData.cont = $event.target.value"
                  ></textarea>
                  <div class="btn">
                    <button @click="submit">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { addMessage } from "@/api/contPublic.js";
import { ElMessage } from "element-plus";
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import "swiper/css"; // 引入 Swiper 基础样式
// import "swiper/css/navigation"; // 引入导航按钮样式
// import "swiper/css/pagination"; // 引入分页器样式
// 引入 Swiper 必要模块
// import { Autoplay, Navigation, Pagination } from "swiper/modules";
// const swiperOptionsH5 = {
//   modules: [Autoplay, Navigation, Pagination], // 确保注册所有需要的模块
//   loop: true,
//   slidesPerView: "auto",
//   spaceBetween: 10,
//   // 关键修复：使用唯一类名匹配按钮
//   pagination: {
//     el: '.h5-swiper-pagination', // 匹配唯一分页器类名
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".h5-swiper-next", // 匹配唯一next按钮
//     prevEl: ".h5-swiper-prev", // 匹配唯一prev按钮
//     clickable: true,
//   },
//   autoplay: {
//     delay: 2000,
//     disableOnInteraction: false,
//     pauseOnMouseEnter: true,
//   },
// };

const showDetail = ref(1);
const changeContent = (val) => {
  showDetail.value = val;
  // console.log(showDetail.value);
};
// 留言
const formData = ref({
  currUid: "",
  phone: "",
  cont: "",
  temp2: "International SMS",
});
const choose = (val) => {
  formData.value.temp2 = val;
};
const submit = () => {
  if (!formData.value.currUid) {
    ElMessage.error("Please enter your name");
    return;
  } else if (!formData.value.phone) {
    ElMessage.error("Please enter your phone number");
    return;
  } else if (!formData.value.cont) {
    ElMessage.error("Please enter your message");
    return;
  } else {
    if (formData.value) {
      addMessage(formData.value).then((res) => {
        // console.log(res,'res');

        if (res.data.code === 0) {
          // 提交成功后的处理逻辑
          ElMessage.success("留言提交成功！");
          formData.value = {
            currUid: "",
            phone: "",
            cont: "",
            temp2: "International SMS",
          }; // 清空表单数据
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.error("表单数据为空");
    }
  }
};
</script>
<style lang="scss" scoped>
// .contain {
//   width: 1200px;
//   margin: 0 auto;
//   box-sizing: border-box;
// }
.contain {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.homeindex {
  .topbanner {
    width: 100%;
    height: 365px;
    position: relative;
    background-image: url("../assets/img/newhome/banner2.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    img {
      width: 100%;
      height: 100%;
    }
    .bancontop {
      position: absolute;
      width: 560px;
      height: 180px;
      top: 35%;
      left: 35%;
      transform: translate(-50%, -50%);
      h2 {
        font-size: 40px;
        font-family: "PingFang SC";
        font-weight: bold;
        color: #1456f0;
        line-height: 50px;
        text-align: left;
        font-style: normal;
      }
    }
    .bannergroup {
      text-align: center;
      position: absolute;
      bottom: -50px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      box-shadow: 0px 4px 4px #dddddd;
      border-radius: 10px;
      .nav-group {
        display: flex;
        justify-content: space-between;
        .nav-item {
          padding: 20px 40px;
          text-align: center;
          .nav-title {
            font-weight: bold;
            color: #182204;
            font-size: 18px;
          }
          .nav-desc {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: bold;
            font-size: 14px;
            color: #182204;
            line-height: 20px;
            text-align: center;
            font-style: normal;
          }
        }
      }
    }
    .bannergroup_h5 {
      display: none;
    }
  }
  .main {
    width: 100%;
    padding: 40px 0;
    margin-top: 50px;
    .feature-title {
      text-align: center;
      margin-bottom: 44px;
      h2 {
        font-family: "PingFang-SC, PingFang-SC";
        font-weight: 800;
        font-size: 36px;
        color: #182204;
        line-height: 50px;
        text-align: center;
        font-style: normal;
      }
    }
    .main-content {
      display: flex;
      justify-content: center;
      .feature-list {
        width: 220px;
        display: flex;
        flex-direction: column;
        // gap: 30px;
        .active {
          background: #f2f9ff;
        }
        .feature-item {
          display: flex;
          align-items: center;
          gap: 10px;
          justify-content: center;
          flex-wrap: wrap;
          align-content: center;
          width: 200px;
          height: 124px;
          img {
            width: 44px;
            height: 44px;
            margin: 0 78px 16px;
          }
          div {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #182204;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            margin: 0 14px 24px;
          }
        }
      }
      .feature-detail {
        flex: 1;
        margin-left: 60px;
        h2 {
          font-size: 28px;
          color: #2d3a4b;
          margin-bottom: 20px;
        }
        .feature-desc {
          font-size: 15px;
          color: #333;
          margin-bottom: 20px;
          width: 465px;
          height: 515px;
          // margin: 0 57px 0 28px;
          p {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 800;
            font-size: 20px;
            color: #182204;
            line-height: 28px;
            text-align: left;
            padding-bottom: 38px;
            font-style: normal;
          }
          ul {
            margin: 0;
            padding-left: 20px;
            li {
              margin-bottom: 10px;
              b {
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 800;
                font-size: 16px;
                color: #182204;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                padding-bottom: 10px;
              }
              p {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #182204;
                line-height: 22px;
                text-align: left;
                font-style: normal;
              }
            }
          }
        }
        .feature-imgright {
          margin-top: 60px;
          .feature-img {
            width: 450px;
            height: 380px;
            margin-top: 20px;
          }
        }
      }
    }
  }
  .busines {
    // height: 740px;
    width: 100%;
    background: #edf0f4;
    padding-top: 50px;
    .busines-title {
      h2 {
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 800;
        font-size: 36px;
        color: #182204;
        line-height: 50px;
        text-align: center;
        font-style: normal;
      }
    }
    .busines-cont {
      // width: 100%;
      .busines-list {
        width: 100%;
        margin-top: 60px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .busines-item {
          // height: 302px;
          background-color: #fff;
          width: 30%;
          display: flex;
          flex-wrap: nowrap;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 20px;
          padding: 24px 30px 24px 21px;
          margin-right: 33px;
          margin-bottom: 24px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .busines-img {
            width: 90px;
            height: 90px;
            flex-shrink: 0;
          }
          .bus-ri {
            flex: 1;
            .bus-title {
              h4 {
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 700;
                font-size: 18px;
                color: #182204;
                line-height: 25px;
                text-align: left;
                font-style: normal;
                margin-bottom: 12px;
              }
            }
            .bus-desc {
              p {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #182204;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }
  .mapword {
    // width: 100%;
    .mapword-title {
      text-align: center;
      margin: 50px auto;
      h2 {
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 800;
        font-size: 36px;
        color: #182204;
        line-height: 50px;
        text-align: center;
        font-style: normal;
      }
    }
    .mapword-box {
      height: 445px;
      background-image: url("../assets/img/newhome/map@2x-2048x758.png");
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      margin-bottom: 30px;
      .mapword-cont {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .numword {
          width: 25%;
          .num {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: bold;
            font-size: 28px;
            color: #127feb;
            line-height: 40px;
            text-align: center;
            font-style: normal;
          }
          .con {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 18px;
            color: #182204;
            line-height: 25px;
            text-align: center;
            font-style: normal;
          }
        }
      }
    }
  }
  .contact-us {
    width: 100%;
    background: #edf0f4;
    .contact-us-title {
      margin: 50px auto;
      padding-top: 50px;
      h2 {
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 800;
        font-size: 36px;
        color: #182204;
        line-height: 50px;
        text-align: center;
        font-style: normal;
      }
    }
    .contact-us-contain {
      .contact-us-box {
        display: flex;
        .contact-us-left {
          margin-right: 33px;
          img {
            width: 420px;
            height: 375.45px;
          }
        }
        .contact-us-right {
          flex-basis: 60%;
          .contact-us-right-cont-box {
            h5 {
              font-family: PingFang-SC, PingFang-SC;
              font-weight: 500;
              font-size: 36px;
              color: #182204;
              line-height: 50px;
              text-align: left;
              font-style: normal;
            }
            h6 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 18px;
              color: #182204;
              line-height: 25px;
              text-align: left;
              font-style: normal;
            }
            .contact-form {
              .form {
                width: 80%;
                padding-bottom: 20px;
                input {
                  display: block;
                  width: 100%;
                  border: 1px solid #e7e7e7;
                  border-radius: 4px;
                  padding: 0 10px;
                  margin-bottom: 20px;
                  font-size: 14px;
                  height: 44px;
                }
                div {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 18px;
                  color: #182204;
                  line-height: 25px;
                  text-align: left;
                  font-style: normal;
                }
                .check {
                  margin: 20px 0 0;
                  button {
                    margin-bottom: 20px;
                    min-width: 88px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #e7e7e7;
                    background-color: #fff;
                    margin-right: 14px;
                    white-space: nowrap;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    padding: 0 10px;
                    cursor: pointer;
                  }
                  .active {
                    background-color: #127feb;
                    color: #fff;
                  }
                }
                textarea {
                  display: block;
                  width: 100%;
                  border: 1px solid #e7e7e7;
                  border-radius: 4px;
                  padding: 10px;
                  margin-bottom: 20px;
                  font-size: 14px;
                  height: 88px;
                  -webkit-box-sizing: border-box;
                  box-sizing: border-box;
                }
                .btn {
                  width: 100%;
                  text-align: center;
                  button {
                    min-width: 180px;
                    height: 40px;
                    border-radius: 20px;
                    margin-right: 14px;
                    cursor: pointer;
                    background-color: #127feb;
                    color: #fff;
                    border: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .homeindex {
    width: 100%;
    margin-top: 63px;
  }
  .contain {
    width: 100%; // 原固定1200px改为占满屏幕宽度
    // max-width: 1200px; // 保留最大宽度限制，避免大屏内容过宽
    // padding: 0 15px; // 添加左右内边距，防止内容贴边
    box-sizing: border-box; // 内边距计入宽度
  }
  .topbanner {
    position: relative;
    height: 400px !important;
    .bancontop {
      width: 100% !important;
      position: absolute;
      height: 100px !important;
      top: 25% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      h2 {
        font-size: 24px !important; /* 缩小标题字体 */
        line-height: 32px !important;
      }
    }
    .bannergroup {
      display: none !important;
    }
    .bannergroup_h5 {
      display: block !important;
      position: absolute;
      bottom: 10px !important;
      width: 100%;
      // 轮播容器样式
      // ::v-deep(.h5-swiper) {
      //   width: 100%;
      //   position: relative; // 确保按钮相对于轮播容器定位

      // // 前进/后退按钮样式
      // .swiper-button-prev,
      // .swiper-button-next {
      //   width: 30px; // 小屏幕按钮尺寸
      //   height: 30px;
      //   background-color: rgba(255, 255, 255, 0.534); // 白色半透明背景
      //   border-radius: 50%; // 圆形按钮
      //   top: 60%; // 垂直居中
      //   transform: translateY(-50%);
      //   background-size: 15px 15px; // 箭头图标大小
      //   color: #686869; // 箭头颜色
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   z-index: 10; // 确保在轮播内容上方
      // }
      // // 左按钮位置（左边缘）
      // .swiper-button-prev {
      //   left: 5px;
      //   &::after {
      //     font-family: swiper-icons;
      //     font-size: 15px;
      //     text-transform: none !important;
      //     letter-spacing: 0;
      //     font-variant: initial;
      //     line-height: 1;
      //   }
      // }
      // // 右按钮位置（右边缘）
      // .swiper-button-next {
      //   right: 5px;
      //   &::after {
      //     font-family: swiper-icons;
      //     font-size: 15px;
      //     text-transform: none !important;
      //     letter-spacing: 0;
      //     font-variant: initial;
      //     line-height: 1;
      //   }
      // }

      // // 分页器样式（底部居中）
      // .swiper-pagination {
      //   bottom: -10px; // 位于轮播容器底部外侧
      //   text-align: center;

      //   // 分页器圆点样式
      //   .h5-swiper-bullet {
      //     width: 8px;
      //     height: 8px;
      //     margin: 0 4px; // 圆点之间的间距
      //     background-color: rgba(255, 255, 255, 0.5); // 未激活状态颜色
      //     border-radius: 50%;
      //   }
      //   // 激活状态的圆点
      //   .h5-swiper-bullet-active {
      //     background-color: #127feb; // 激活状态颜色（与品牌色一致）
      //     width: 20px; // 激活时变长，突出显示
      //     border-radius: 4px; // 椭圆形状
      //   }
      // }

      // // 轮播页内容样式
      // .swiper-slide {
      //   flex-shrink: 0;
      //   padding: 0 10px;
      // }
      // .nav-item {
      //   border-bottom: none !important; // 去掉底部边框;
      //   min-width: 140px;
      //   min-height: 110px;
      //   flex: 1;
      //   padding: 10px;
      //   text-align: center;
      //   color: white; // 文字颜色（与深色背景对比）
      //   border-right: 1px solid rgba(255, 255, 255, 0.3);
      //   background-color: rgba(0, 0, 0, 0.15);
      //   &:last-child {
      //     border-right: none; // 最后一个item去掉右边框
      //   }
      //   .nav-title {
      //     font-size: 16px;
      //     margin-bottom: 5px;
      //   }
      //   .nav-desc {
      //     font-size: 12px;
      //     opacity: 0.9;
      //   }
      // }
      // }
      ::v-deep( .h5-carousel) {
  width: 100%;
  padding: 0 15px;
  .el-carousel__container {
    height: 120px !important;
  }
  // 轮播项样式
  .el-carousel__item {
    height: 120px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    .nav-item {
        border-bottom: none !important; // 去掉底部边框;
        min-width: 140px;
        min-height: 110px;
        flex: 1;
        padding: 10px;
        text-align: center;
        color: white; // 文字颜色（与深色背景对比）
        border-right: 1px solid rgba(255, 255, 255, 0.3);
        background-color: rgba(0, 0, 0, 0.15);
        &:last-child {
          border-right: none; // 最后一个item去掉右边框
        }
        .nav-title {
          font-size: 16px;
          margin-bottom: 5px;
        }
        .nav-desc {
          font-size: 12px;
          opacity: 0.9;
        }
      }
  }
  .el-carousel__indicators--outside {
        display: none !important;
    }
  // 箭头按钮样式
  .el-carousel__arrow {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.8);
    color: #127feb;
    opacity: 1;
    
    &:hover {
      background-color: #fff;
      color: #127feb;
    }
    
    // 箭头图标调整
    &::before {
      font-size: 16px;
    }
  
  }
  
  // 左箭头位置
  .el-carousel__arrow--left {
    left: 0;
  }
  
  // 右箭头位置
  .el-carousel__arrow--right {
    right: 0;
  }
  
  // 指示器样式
  .el-carousel__indicators--outside {
    bottom: -25px;
    
    .el-carousel__indicator {
      width: 8px;
      height: 8px;
      margin: 0 4px;
      
      &.is-active {
        width: 20px;
        border-radius: 4px;
        background-color: #127feb;
      }
    }
  }
}
    }
    .workgroup-con.nav-group {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start !important;
    }
  }
  .main .main-content {
    flex-direction: column; /* 改为纵向排列 */
    justify-content: center;
    align-items: center;
    .feature-list {
      width: 100%;
      flex-direction: row; /* 功能按钮横向排列 */
      justify-content: center;
      gap: 10px;
      .feature-item {
        width: 30%; /* 每个按钮占30%宽度 */
        height: auto;
        padding: 10px;
        img {
          margin: 0 0 8px;
        }
        div {
          font-size: 14px;
        }
      }
    }
    .feature-detail {
      margin: 15px auto !important;
      .feature-desc {
        width: 100% !important; /* 详情内容占满宽度 */
        height: auto;
        padding: 15px;
        ul {
          li {
            margin-bottom: 0px !important;
          }
        }
        p {
          font-size: 18px !important;
        }
      }
    }
    .feature-imgright .feature-img {
      width: 300px !important; /* 图片宽度自适应 */
      height: auto;
    }
  }
  .homeindex .busines .busines-cont .busines-list {
    display: block;
  }
  .busines .busines-cont .busines-list .busines-item {
    width: 100% !important; /* 小屏幕下单列显示 */
    margin-right: 0;
    background-color: #fff;
    .busines-img {
      width: 60px; /* 缩小图标尺寸 */
      height: 60px;
    }
    .bus-ri .bus-title h4 {
      font-size: 16px;
    }
    .bus-ri .bus-desc p {
      font-size: 14px;
    }
  }
  .mapword .mapword-box {
    height: 300px !important; /* 缩小背景图高度 */
    .mapword-cont {
      flex-wrap: wrap; /* 数据项换行显示 */
      justify-content: center;
      .numword {
        width: 50% !important; /* 每两项占一行 */
        margin-bottom: 20px;
        .num {
          font-size: 24px;
        }
        .con {
          font-size: 16px;
        }
      }
    }
  }
  .contact-us .contact-us-box {
    flex-direction: column; /* 改为纵向排列 */
    .contact-us-left {
      margin-right: 0 auto;
      img {
        width: 100% !important; /* 图片宽度自适应 */
        height: auto;
      }
    }
    .contact-us-right {
      .contact-form .form {
        width: 100%; /* 表单占满宽度 */
        input,
        textarea {
          height: 36px; /* 缩小输入框高度 */
          font-size: 12px;
        }
        .check button {
          min-width: 70px; /* 缩小按钮尺寸 */
          height: 32px;
          font-size: 12px;
        }
      }
    }
  }
}
@media (max-width: 375px) {
  .contain {
    width: 375px !important;
  }
  .mapword-cont {
    flex-wrap: wrap;
  }
  .numword {
    width: 50% !important; /* 小屏幕下每行显示2个数据块 */
    margin-bottom: 20px;
  }
}
</style>
